import "./Category.scss";

import service1 from "../../../assets/category/service-9.jpeg";
import service2 from "../../../assets/category/service-10.jpeg";
import service3 from "../../../assets/category/service-3.jpg";
import service4 from "../../../assets/category/service-11.jpeg";
import serviceicon from "../../../assets/logo/sec-title-icon.jpg";
import servicelogo from "../../../assets/logo/logo.png";
import adventure_icon from '../../../assets/logo/adventure.png';
import accomodation_icon from '../../../assets/logo/accomodation.png';
import restaurant_icon from '../../../assets/logo/restaurent.png';
import WeddingEvents_icon from '../../../assets/logo/wed1.png';

const Category = () => {
    return (
<div>
    <div className="catti">
        <div className="service_title1">
            <div className="service_title">
                <img src={serviceicon} alt=''/>
                <h5 style={{textTransform:'capitalize'}}>A Resort with Infinite Possibilities  </h5>
                <h1>Adventure | Accommodation | Restaurant | Wedding & Events </h1>
            </div>
        </div>
    </div> 
{/*............category title end......................................................*/ }    
    <div className="shop-by-category">
        <div className="categories row p-3">
            <div className="category">
                <img src={service1} alt='' height={'300px'}/>
                <div className='servicelogodiv'><img src={servicelogo} className='servicelogo'alt=''/>
                </div>
                {/* <div className='caption'><img src={adventure_icon} className='capimg' alt=''/>
                </div> */}
                <div className='servicecaption'><h3><b>Adventure</b></h3>
                    <p>One Destination for all the adventure enthusiasts.</p>
                    <button className="arrow-btn">
                         <span className="arrow">→</span>
                    </button>
                </div>
            </div>
            {/*.............category adventure 1 end...................*/}        
            <div className="category">
                <img src={service2} alt='' height={'300px'}/>
                <div className='servicelogodiv'><img src={servicelogo} className='servicelogo'alt=''/>
                </div>
                {/* <div className='caption'><img src={accomodation_icon} className='capimg' alt=''/>
                </div> */}
                <div className='servicecaption'><h3><b>Accommodation</b></h3>
                    <p>
                        Get out, go out. It's wonderful out there in the Grand Machal a man-made jungle.
                    </p>
                    <button className="arrow-btn">
                         <span className="arrow">→</span>
                    </button>
                </div>    
            </div>
            {/*.............category adventure 2 end...................*/}  
            <div className="category">
                <img src={service3} alt='' height={'300px'}/>
                <div className='servicelogodiv'><img src={servicelogo} className='servicelogo'alt=''/>
                </div>
                {/* <div className='caption'><img src={restaurant_icon} className='capimg' alt=''/>
                </div> */}
                <div className='servicecaption'><h3><b>Restaurant</b></h3>
                     <p>
                        The restaurant is the perfect place to convene with colleagues or friends after a busy day in Indore.
                     </p>
                     <button className="arrow-btn">
                        <span className="arrow">→</span>
                    </button>
                </div>
            </div>
            {/*.............category adventure 3 end...................*/}  
            <div className="category">
                <img src={service4} alt='' height={'300px'}/>
                <div className='servicelogodiv'><img src={servicelogo} className='servicelogo'alt=''/>
                </div>
                {/* <div className='caption'><img src={WeddingEvents_icon} className='capimg' alt=''/>
                </div> */}
                <div className='servicecaption'><h3><b>Wedding & Events</b></h3>
                    <p>Gracefully designed to play host to numerous events.Our resort is the ideal destination for your event.</p>
                    <button className="arrow-btn">
                        <span className="arrow">→</span>
                    </button>
                </div>
            </div>
             {/*.............category adventure 4 end...................*/}  
        </div>

    </div>{/*categories end*/}
</div>
);
};

export default Category;
